module.exports = __webpack_public_path__ + "img/tc6.3a7ac5bb.png";